import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = { class: "month-nav" }
const _hoisted_4 = { class: "calendar" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "trade-indicators"
}
const _hoisted_7 = { class: "sidebar" }
const _hoisted_8 = { class: "stats" }
const _hoisted_9 = { class: "wr" }
const _hoisted_10 = { class: "rules" }
const _hoisted_11 = { class: "rules-title" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
        }, "◄"),
        _createElementVNode("h2", null, _toDisplayString(_ctx.currentMonth), 1),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
        }, "►")
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysInMonth, (day, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "day",
            onClick: ($event: any) => (_ctx.goToTradeList(day))
          }, [
            _createElementVNode("div", null, _toDisplayString(day), 1),
            (_ctx.tradeResults[day])
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tradeResults[day], (status, tradeIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: tradeIndex,
                      class: _normalizeClass(["trade-indicator", status])
                    }, null, 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_5))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _cache[4] || (_cache[4] = _createTextVNode(" WR : ")),
        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.winRate) + "%", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleEditRules && _ctx.toggleEditRules(...args)))
          }, _toDisplayString(_ctx.editingRules ? "💾" : "🖊️"), 1),
          _cache[5] || (_cache[5] = _createTextVNode(" RULES : "))
        ]),
        (!_ctx.editingRules)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(rule), 1))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "rule-input-container"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": ($event: any) => ((_ctx.rules[index]) = $event),
                    class: "rule-input"
                  }, null, 8, _hoisted_14), [
                    [_vModelText, _ctx.rules[index]]
                  ]),
                  _createElementVNode("button", {
                    onClick: ($event: any) => (_ctx.removeRule(index)),
                    class: "remove-btn"
                  }, "❌", 8, _hoisted_15)
                ]))
              }), 128)),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addRule && _ctx.addRule(...args))),
                class: "add-btn"
              }, "➕")
            ]))
      ])
    ])
  ]))
}